import { type OccasionInfoTooltipOccasion } from './occasionInfoTooltipCopy';

type CloseHandler = () => void;

const closeHandlers = new Map<OccasionInfoTooltipOccasion, CloseHandler>();

export function registerOccasionInfoTooltip(
  occasion: OccasionInfoTooltipOccasion,
  close: CloseHandler
) {
  closeHandlers.set(occasion, close);

  return () => {
    closeHandlers.delete(occasion);
  };
}

export function notifyOccasionInfoTooltipOpening(
  occasion: OccasionInfoTooltipOccasion
) {
  closeHandlers.forEach((close, registeredOccasion) => {
    if (registeredOccasion !== occasion) {
      close();
    }
  });
}
